<script>

    import { userStore } from '../stores'

    import View from '../$layouts/view.layout.svelte'    
    import ModalContainer from '../$components/modal.container.svelte'
    import TitleHero from '../$components/title.hero.svelte'
    
    import UserView from './view.user.svelte'
    import UsersComponent from './component.users.svelte'
    import UsersReportComponent from './component.report.svelte'
    import UserCreateComponent from './component.create.svelte'

    import NotificationComponent from '../notifications/component.notification.svelte'
    import NotificationsGlobalComponent from '../notifications/component.notifications.global.svelte'
    import NotificationCreateComponent from '../notifications/component.create.svelte'
    import NotificationUpdateComponent from '../notifications/component.update.svelte'

</script>

<View>
    {#if !$userStore}
        <TitleHero title="Usuarios" subtitle="Consulta y gestión de usuarios" />
        <UsersComponent />
    {:else}
        <UserView />
    {/if}
</View>

<ModalContainer id="notifications_global_modal" title="Notificación Global" >
    <NotificationsGlobalComponent />
    <NotificationCreateComponent type='global' />
</ModalContainer>

<ModalContainer id="notification_modal" title="Notificación Global" >
    <NotificationComponent />
</ModalContainer>

<ModalContainer id="notification_update_modal" title="Notificación Global" >
    <NotificationUpdateComponent />
</ModalContainer>

<ModalContainer id="users_report_modal" title="Reporte usuarios" >
    <UsersReportComponent />
</ModalContainer>

<ModalContainer id="users_create_modal" title="Crear usuario" >
    <UserCreateComponent />
</ModalContainer>